import React, { useEffect, useRef, useState } from 'react';
import {  Divider, Table, Popconfirm, Card, Tooltip, Switch,Input,Button,Tag,Row, Col, Drawer } from 'antd';
import {PackingMethodDto} from '@gtpl/shared-models/masters';
import {PackingMethodService} from '@gtpl/shared-services/masters';
import {  Link } from "react-router-dom";
import {CheckCircleOutlined,CloseCircleOutlined,RightSquareOutlined,EyeOutlined,EditOutlined,SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { ColumnProps } from 'antd/lib/table';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import {PackingMehodsForm} from '@gtpl/pages/master/master-components/packing-methods-form'

import './packing-methods-grid.css'; 
import { UnitsOfWeightInput } from '@gtpl/shared-models/sale-management';
import { EmployeeRolesEnum, UserRequestDto } from '@gtpl/shared-models/common-models';

/* eslint-disable-next-line */
export interface PackingMethodsGridProps {}

export function PackingMethodsGrid(props: PackingMethodsGridProps) {
  const searchInput = useRef(null);
  const [page, setPage] = React.useState(1);
  const [searchText, setSearchText] = useState(''); 
  const [searchedColumn, setSearchedColumn] = useState('');

  const [drawerVisible, setDrawerVisible] = useState(false);
  const [packingMethodData, setPackingMethodData] = useState<PackingMethodDto[]>([]);
  const [selectedPackingMethodData, setSelectedPackingMethodData] = useState<any>(undefined);
  let unitOfWeights = UnitsOfWeightInput;
  
  const packingMethodDataService=new PackingMethodService();

  useEffect(() => {
    getAllPackingMethods();
  }, []);

  

  /**
   * 
   */
  const getAllPackingMethods= () => {
    packingMethodDataService.getAllPackingMethod(new UserRequestDto(JSON.parse(localStorage.getItem('username')))).then(res => {
      console.log(res);
      if (res.status) {
        setPackingMethodData(res.data);
      } else {
        if (res.intlCode) {
          setPackingMethodData([]);
            AlertMessages.getErrorMessage(res.internalMessage);
        } else {
         AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      setPackingMethodData([]);
      AlertMessages.getErrorMessage(err.message);
    })
  }
  /**
   * 
   * @param productData 
   */
  const deletePackingMethod = (productData:PackingMethodDto) => {
    productData.isActive=productData.isActive?false:true;
    packingMethodDataService.activatedActivatePackingMethod(productData).then(res => { console.log(res);
      if (res.status) {
        getAllPackingMethods();
        AlertMessages.getSuccessMessage('Success'); 
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })
  }
   
    /**
     * 
     * @param variantData 
     */
    const updatePackingMethod = (packingMethodData: PackingMethodDto) => {
      packingMethodData.updatedUser= JSON.parse(localStorage.getItem('username'))
      packingMethodDataService.updatePackingMethod(packingMethodData).then(res => { console.log(res);
        if (res.status) {
          AlertMessages.getSuccessMessage('Updated Successfully');
          getAllPackingMethods();
          setDrawerVisible(false);
        } else {
          if (res.intlCode) {
            AlertMessages.getErrorMessage(res.internalMessage);
          } else {
            AlertMessages.getErrorMessage(res.internalMessage);
          }
        }
      }).catch(err => {
        AlertMessages.getErrorMessage(err.message);
      })
    }
   /**
   * used for column filter
   * @param dataIndex column data index
   */
  const getColumnSearchProps = (dataIndex:string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={ searchInput }
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
    record[dataIndex]
    ? record[dataIndex]
       .toString()
        .toLowerCase()
        .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) {    setTimeout(() => searchInput.current.select());   }
    },
    render: text =>
      text ?(
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) :text
      )
      : null
     
  });

  /**
   * 
   * @param selectedKeys 
   * @param confirm 
   * @param dataIndex 
   */
  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  };

    //drawer related
    const closeDrawer=()=>{
      setDrawerVisible(false);
    }
  
    //TO open the form for updation
    const openFormWithData=(viewData: PackingMethodDto)=>{
      setDrawerVisible(true);
      setSelectedPackingMethodData(viewData);
    }


  const columnsSkelton: ColumnProps<any>[] = [
    {
      title: 'S No',
      key: 'sno',
      width: '70px',
      responsive: ['sm'],
      render: (text, object, index) => (page-1) * 10 +(index+1)
    },
    {
      title: 'Packing Method',
      dataIndex: 'packingMethodName',
      // responsive: ['lg'],
      sorter: (a, b) => a.packingMethodName.localeCompare(b.packingMethodName),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('packingMethodName')
    },
    {
      title: 'No. Of Pouches',
      dataIndex: 'noOfPouches',
      // responsive: ['lg'],
      sorter: (a, b) => a.noOfPouches - b.noOfPouches,
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('noOfPouches')
    },
    ,
    {
      title: 'Pouches Weight',
      dataIndex: 'pouchesPerRow',
      // responsive: ['lg'],
      sorter: (a, b) => a.pouchesPerRow - b.pouchesPerRow,
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('pouchesPerRow')
    },
    {
      title: 'Gross Weight(In KGs)',
      dataIndex: 'grossWeight',
      // responsive: ['lg'],
      sorter: (a, b) => a.grossWeight - b.grossWeight,
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('grossWeight')
    },
    {
      title: 'Pallet Capacity',
      dataIndex: 'palletCapacity',
      // responsive: ['lg'],
      sorter: (a, b) => a.palletCapacity - b.palletCapacity,
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('palletCapacity')
    },
    // {
    //   title: 'UOMs Name',
    //   dataIndex: 'uomName',
    //   // responsive: ['lg'],
    //   sorter: (a, b) => a.uomName?.localeCompare(b.uomName),
    //   // render: (uomId, rowData) => (
    //   //   <>
    //   //     {unitOfWeights.find(uom=>uom.value==uomId).name}
    //   //   </>
    //   // ),
    //   sortDirections: ['descend', 'ascend'],
    //   ...getColumnSearchProps('uomName')
    // },
    {
      title: 'Status',
      dataIndex: 'isActive',
      render: (isActive, rowData) => (
        <>
          {isActive?<Tag icon={<CheckCircleOutlined />} color="#87d068">Active</Tag>:<Tag icon={<CloseCircleOutlined />} color="#f50">In Active</Tag>}
        </>
      ),
      filters: [
        {
          text: 'Active',
          value: true,
        },
        {
          text: 'InActive',
          value: false,
        },
      ],
      filterMultiple: false,
      onFilter: (value, record) => 
      {
        // === is not work
        return record.isActive === value;
      },
      
    },
    {
      title:`Action`,
      dataIndex: 'action',
      render: (text, rowData) => (
        <span>         
            <EditOutlined  className={'editSamplTypeIcon'}  type="edit" 
              onClick={() => {
                if (rowData.isActive) {
                  openFormWithData(rowData);
                } else {
                  AlertMessages.getErrorMessage('You Cannot Edit Deactivated Packing Method');
                }
              }}
              style={{ color: '#1890ff', fontSize: '14px' }}
            />
          
          <Divider type="vertical" />
            <Popconfirm onConfirm={e =>{deletePackingMethod(rowData);}}
            title={
              rowData.isActive
                ? 'Are you sure to Deactivate Packing Method ?'
                :  'Are you sure to Activate Packing Method ?'
            }
          >
            <Switch  size="default"
                className={ rowData.isActive ? 'toggle-activated' : 'toggle-deactivated' }
                checkedChildren={<RightSquareOutlined type="check" />}
                unCheckedChildren={<RightSquareOutlined type="close" />}
                checked={rowData.isActive}
              />
            
          </Popconfirm>
        </span>
      )
    }
  ];

  /**
   * 
   * @param pagination 
   * @param filters 
   * @param sorter 
   * @param extra 
   */
  const onChange=(pagination, filters, sorter, extra)=> {
    console.log('params', pagination, filters, sorter, extra);
  }
  return (
    <Card title={<span style={{color:'white'}}>Packing Methods</span>}
    style={{textAlign:'center'}} headStyle={{backgroundColor: '#69c0ff', border: 0 }} extra={<Link to='/Packingmethods-form' ><span style={{color:'white'}} >{(JSON.parse(localStorage.getItem('role'))===EmployeeRolesEnum.SUPER_ADMIN)?'':<Button className='panel_button' >Create </Button>} </span></Link>} >
     <br></br>
     <Row gutter={40}>
      <Col>
          <Card title={'Total Packing Methods: ' + packingMethodData.length} style={{textAlign: 'left', width: 275, height: 41,backgroundColor:'#bfbfbf'}}></Card>
          </Col>
          <Col>
           <Card title={'Active: ' + packingMethodData.filter(el => el.isActive).length} style={{textAlign: 'left', width: 225, height: 41,backgroundColor:'#52c41a'}}></Card>
          </Col>
          <Col>
           <Card title={'In-Active: ' + packingMethodData.filter(el => el.isActive == false).length} style={{textAlign: 'left', width: 225, height: 41,backgroundColor:'#f5222d'}}></Card>
          </Col>
          </Row>
          <br></br>
          <Table
          rowKey={record => record.packingMethodId }
          columns={columnsSkelton}
          dataSource={packingMethodData}
          scroll={{x:true}}
          pagination={{
            onChange(current) {
              setPage(current);
            }
          }}
          onChange={onChange}
          bordered />
        <Drawer bodyStyle={{ paddingBottom: 80 }} title='Update' width={window.innerWidth > 768 ? '70%' : '85%'}
            onClose={closeDrawer} visible={drawerVisible} closable={true}>
            <Card headStyle={{ textAlign: 'center', fontWeight: 500, fontSize: 16 }} size='small'>
              <PackingMehodsForm key={Date.now()}
                updatePackingMethod={updatePackingMethod}
                isUpdate={true}
                packingMehodData={selectedPackingMethodData}
                closeForm={closeDrawer} />
            </Card>
          </Drawer>
     </Card>
  );
}

export default PackingMethodsGrid;
